// extracted by mini-css-extract-plugin
export var askAiIcon = "_o5-j";
export var category = "_o5-9";
export var categoryHeader = "_o5-e";
export var container = "_o5-0";
export var group = "_o5-a";
export var groupItems = "_o5-f";
export var groupSeparator = "_o5-k";
export var loading = "_o5-1";
export var noResults = "_o5-3";
export var placeholder = "_o5-2";
export var resultContent = "_o5-5";
export var resultIcon = "_o5-c";
export var resultItem = "_o5-g";
export var resultMeta = "_o5-8";
export var resultSubtitle = "_o5-7";
export var resultSuffix = "_o5-i";
export var resultTitle = "_o5-6";
export var resultsList = "_o5-4";
export var searchGroup = "_o5-d";
export var selected = "_o5-h";
export var subgroup = "_o5-b";